import { Pipe, PipeTransform } from '@angular/core';
import { PortalProfileModel } from './portal-profile.models';
import { Country } from 'src/app/shared/models/country';
import { LookupService } from 'src/shared-app-portal/services/lookup.service';

@Pipe({
  name: 'portalAddressFormat',
  standalone: false
})
export class PortalAddressFormatPipe implements PipeTransform {
  constructor(private lookupService: LookupService) {}

  async transform(profile: PortalProfileModel): Promise<string> {
    if (!profile) return '';
    let countries = this.lookupService.countries.getValue();
    if (!countries) countries = await this.lookupService.getCountries();
    let states = this.lookupService.states.getValue();
    if (!states) states = await this.lookupService.getStates();
    const country = profile.countryId ? countries.find((c) => c.id === profile.countryId) : null;
    const stateOrRegion = profile.stateId ?? profile.region ?? '';
    const usStates = states.filter((state) => state.country.code === Country.UnitedStates.code);
    const provinces = states.filter((state) => state.country.code === Country.Canada.code);
    const state = stateOrRegion
      ? usStates.find((s) => s.id === stateOrRegion) ||
        provinces.find((p) => p.id === stateOrRegion)
      : null;
    // Compose city, state, and postal code in one line
    let cityStateZip = '';
    if (profile.city) {
      cityStateZip += profile.city;
    }

    cityStateZip += (cityStateZip ? ', ' : '') + (state?.name ? state.name : stateOrRegion);

    if (profile.postalCode) {
      cityStateZip += (cityStateZip ? ' ' : '') + profile.postalCode;
    }
    const parts = [
      profile.streetAddress1,
      profile.streetAddress2,
      cityStateZip || null,
      country?.name.replace('of America', '') || null
    ].filter(Boolean);
    return parts.length ? parts.join('<br>') : '';
  }
}
